/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DetailedPermission } from '../models/DetailedPermission';
import type { RoleRequest } from '../models/RoleRequest';
import type { RoleResponse } from '../models/RoleResponse';
import type { TeamMemberRoleSetRequest } from '../models/TeamMemberRoleSetRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardRoleRestEndpointService {
    /**
     * @returns RoleResponse OK
     * @throws ApiError
     */
    public static getRoles(): CancelablePromise<Array<RoleResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/roles',
        });
    }
    /**
     * @returns RoleResponse OK
     * @throws ApiError
     */
    public static createRole({
        requestBody,
    }: {
        requestBody: RoleRequest,
    }): CancelablePromise<RoleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/roles',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns RoleResponse OK
     * @throws ApiError
     */
    public static getRole({
        id,
    }: {
        id: number,
    }): CancelablePromise<RoleResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/roles/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns RoleResponse OK
     * @throws ApiError
     */
    public static updateRole({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: RoleRequest,
    }): CancelablePromise<RoleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/roles/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteRole({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/roles/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static setRoles({
        teamMemberId,
        requestBody,
    }: {
        teamMemberId: number,
        requestBody: TeamMemberRoleSetRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/roles/member/{teamMemberId}',
            path: {
                'teamMemberId': teamMemberId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns DetailedPermission OK
     * @throws ApiError
     */
    public static getPermissions(): CancelablePromise<Array<DetailedPermission>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/roles/permissions',
        });
    }
}
